import * as React from 'react';

interface IProps {
    courseid: any;
};

export default class TimedQuiz extends React.Component<IProps, {}> {
    public render() {
        return <div>TimedQuiz PlaceHolder</div>;
    }
};
